import { Checkbox } from '@material-ui/core';
import { Field } from 'redux-form/immutable';
import { EDIT_PROJECT_FORM } from 'features/projects/details/details.constants';

const LwiMechanicalWlOnlyToggle = ({ onChange }) => {
  return (
    <Field
      format={null}
      onChange={onChange}
      name={EDIT_PROJECT_FORM.LWI_MECHANICAL_WL_ONLY}
      component={({ input }) => {
        return (
          <Checkbox
            color="default"
            value={input.name}
            onClick={input.onChange}
            checked={!!input.value}
          />
        );
      }}
    />
  );
};

export default LwiMechanicalWlOnlyToggle;
